import { useTranslation } from 'react-i18next'
import Hero from '../components/sections/Hero'
import Banner from '../components/sections/Banner'
import About from '../components/sections/About'
import Services from '../components/sections/Services'
import TCTSYSection from '../components/sections/TCTSYSection'
import Testimonial from '../components/sections/Testimonial'
import GentleYoga from '../components/sections/GentleYoga'
import FAQ from '../components/sections/FAQ'

function Home() {
  const { t } = useTranslation()

  return (
    <div className="w-full">
      <Hero />
      <Banner />
      <About />
      <Services />
      <TCTSYSection />
      <Testimonial />
      <GentleYoga />
      <FAQ />
    </div>
  )
}

export default Home
